import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable} from 'rxjs';
import { FootbarConfig, NavbarConfig, VehicleConfig} from '../models/configuration';
import { getDataTransmissionStates } from 'src/app/units/helpers/unit-helper';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';

// servicios con configuraciones
import { AlertService } from 'src/app/alertas/services/alert.service';
import { DriversService } from 'src/app/drivers/services/drivers.service';
import { EventService } from 'src/app/events/services/event.service';
import { GeofencesService } from 'src/app/geofences/services/geofences.service';
import { GeopointsService } from 'src/app/geopoints/services/geopoints.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { VehicleConfigService } from 'src/app/vehicles/services/vehicle-config.service';
import { StateSettingsHistoryDrawerService } from 'src/app/profile-config/user-config/components/user-history-drawer/service/state-settings-history-drawer.service';
import { StateCustomPanelVehicleService } from 'src/app/vehicles/components/content-panel-vehicles/service/state-custom-panel-vehicle.service';
import { ThemeService } from './theme.service';
import { HistorialService } from 'src/app/historial/services/historial.service';

import { ConfigKeys } from '../models/configuration';

@Injectable({
  providedIn: 'root'
})

export class ConfigurationService {
  // configuracion general / shared
  private footbarConfigSubject = new BehaviorSubject<FootbarConfig>({
    mostrarPeso: true, // peso de la pagina
    mostrarVersion: true,
    mostrarMascota: true,
    mostrarHoraLocal: true,
    mostrarUbicacion: true,
  });
  footbarConfig$: Observable<FootbarConfig> = this.footbarConfigSubject.asObservable();

  public navbarConfigSubject = new BehaviorSubject<NavbarConfig>({
    showpanels: {
      vehiculos: true,
      alertas: true,
      geocercas: true,
      geopuntos: true,
      historial: true,
      reportes: true,
      dashboard: true,
      auditoria: true,
      subcuentas: true,
      conductores: true,
      eventos: true,
      multipantalla: true
    },
    showLogo: true,
  });
  navbarConfig$: Observable<NavbarConfig> = this.navbarConfigSubject.asObservable();

  constructor(
    private localStorageService : LocalStorageService,
    private alertService : AlertService, // alertConfig
    private driverService : DriversService, // configuration
    private eventService : EventService, // config
    private geofenceService : GeofencesService, // configuration
    private geopointService : GeopointsService, // config
    private vehicleService : VehicleService, // configuration (analizar con la configuracion de rafa)
    private vehicleConfigService : VehicleConfigService,
    private http : HttpClient,
    private historyDrawerService : StateSettingsHistoryDrawerService,
    private customPanelVehicleService : StateCustomPanelVehicleService,
    private themeService : ThemeService,
    private historialService : HistorialService
  ) {
    console.log("configuration : loadConfiguration")
    this.loadConfiguractionServiceFromStorage();
    this.loadConfigurationFromDatabase();
  }

  setFootbarConfig(config: Partial<FootbarConfig>) {
    const current = this.footbarConfigSubject.value;
    this.footbarConfigSubject.next({...current, ...config});
  }

  setNavbarConfig(update: Partial<NavbarConfig>) {
    const current = this.navbarConfigSubject.value;

    // Si se pasa un update.showpanels, hacemos merge con el actual
    if (update.showpanels) {
      const mergedShowpanels = {
        ...current.showpanels,
        ...update.showpanels,
      };

      this.navbarConfigSubject.next({
        ...current,
        ...update,
        showpanels: mergedShowpanels,
      });
    } else {
      // Si no hay showpanels, solo mezclamos el resto
      this.navbarConfigSubject.next({
        ...current,
        ...update,
      });
    }
  }


  public getConfigurationFromService() {
    const config: Record<string, any> = {
      [ConfigKeys.THEME]: this.themeService.getConfiguration(),
      [ConfigKeys.NAVBAR]: this.navbarConfigSubject.getValue(),
      [ConfigKeys.ALERT]: this.alertService.alertConfig,
      [ConfigKeys.DRIVER]: this.driverService.configuration,
      [ConfigKeys.EVENT]: this.eventService.config,
      [ConfigKeys.GEOFENCE]: this.geofenceService.configuration,
      [ConfigKeys.GEOPOINT]: this.geopointService.config,
      [ConfigKeys.VEHICLE]: this.vehicleConfigService.configuration,
      [ConfigKeys.HISTORY]: this.historialService.config,
      [ConfigKeys.HISTORY_DRAWER]: this.historyDrawerService.getCurrentConfig(),
      [ConfigKeys.VEHICLE_CARD]: this.customPanelVehicleService.getConfigurationPanel(),
    };


    console.log("get configuration", config)

    const result: Record<string, any> = {};
    Object.keys(config).forEach((key) => {
      const value = config[key];
      if (value !== null && value !== undefined) {
        result[key] = value;
      }
    });

    return result;
  }


  public saveConfiguration() {
    let settings = this.getConfigurationFromService();
    console.log("configuration : save settgin to database ", settings)
    this.saveConfigurationToDatabase(settings)
  }


  // save configuration in the database
  public saveConfigurationToDatabase(settings : any) {
    let request = {
      settings
    }
    console.log("configuration : request to post setting", request)
    return this.http.post(`${environment.apiUrl}/api/user/settings`,request).subscribe({
      next: (response) => {
          // ✅ Éxito - respuesta del servidor
          console.log('Respuesta del servidor:', response);
          // aquí puedes mostrar un mensaje o hacer otras acciones
        },
        error: (error) => {
          // ❌ Error al enviar
          console.error('Error al enviar datos al servidor:', error);
          // aquí puedes mostrar un mensaje de error al usuario
        }
    })
  }
  public async loadConfigurationFromDatabase() {
    let response : any = await this.http.get(`${environment.apiUrl}/api/user/settings`).toPromise();
    if(response?.status == "success"){
      let settings = response.settings;
      console.log(settings, "user configuration settings")
      this.setConfigurationsToServices(settings)
      this.saveConfiguractionServiceToStorage();
    }
  }

  // Save configuracion in the storage
  public saveConfiguractionServiceToStorage() {
    let settings = this.getConfigurationFromService();
    console.log("configuration : save configuration from localstorage", settings);

    Object.entries(settings).forEach(([key, value]) => {
      try {
        this.localStorageService.setItem(key, value);
      } catch (e) {
        console.error("Error al guardar configuración:", key, value, e);
      }
    });
  }
  public getAllConfigurationsFromLocalStorage() {
    const settings: any = {};
    Object.values(ConfigKeys).forEach((key) => {
      const storedValue = this.localStorageService.getItem(key);
      try {
        settings[key] = storedValue;
      } catch (e) {
        console.warn("Error parseando configuración:", key, storedValue, e);
        // settings[key] = storedValue; // fallback por si no es JSON válido
      }
    });

    console.log("configuration : get all configuration keys", settings);
    return settings;
  }
  // Load configuracion from the storage
  public loadConfiguractionServiceFromStorage() {
    console.log("configuration : load configuration from localstorage");

    const settings = this.getAllConfigurationsFromLocalStorage();

    this.setConfigurationsToServices(settings)
  }


  private isValidSetting(value: any): boolean {
    if (value === undefined || value === null) return false;
    if (typeof value === 'string' && value.trim() === '') return false;
    if (Array.isArray(value) && value.length === 0) return false; // 🔹 detecta lista vacía
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return false;
    return true;
  }

  // utils
  private setConfigurationsToServices(settings: any) {
    if (!settings || typeof settings !== 'object') return;

    console.log("configuration : validate settings to apply to services", settings)

    // NAVBAR
    const navbar = settings[ConfigKeys.NAVBAR];
    if (this.isValidSetting(navbar)) {
      this.navbarConfigSubject.next(navbar);
    }

    // ALERT
    const alert = settings[ConfigKeys.ALERT];
    if (this.isValidSetting(alert)) {
      this.alertService.alertConfig = alert;
    }

    // DRIVER
    const driver = settings[ConfigKeys.DRIVER];
    if (this.isValidSetting(driver)) {
      this.driverService.configuration = driver;
    }

    // EVENT
    const event = settings[ConfigKeys.EVENT];
    if (this.isValidSetting(event)) {
      this.eventService.config = {
        ...this.eventService.config, // valores por defecto
        ...event // lo que viene guardado
      };
    }

    // GEOFENCE
    const geofence = settings[ConfigKeys.GEOFENCE];
    if (this.isValidSetting(geofence)) {
      this.geofenceService.configuration = geofence;
    }

    // GEOPOINT
    const geopoint = settings[ConfigKeys.GEOPOINT];
    if (this.isValidSetting(geopoint)) {
      this.geopointService.config = geopoint;
    }

    // VEHICLE
    const vehicle = settings[ConfigKeys.VEHICLE];
    if (this.isValidSetting(vehicle)) {
      this.vehicleConfigService.configuration = vehicle;
      this.vehicleConfigService.setVehicleDisplayConfig();
      this.vehicleConfigService.setShowIconTransmission();
    }

    // HISTORY_DRAWER
    const historyDrawer = settings[ConfigKeys.HISTORY_DRAWER];
    if (this.isValidSetting(historyDrawer)) {
      this.historyDrawerService.setConfig = historyDrawer;
    }

    // HISTORY
    const historyConfig = settings[ConfigKeys.HISTORY];
    if (this.isValidSetting(historyConfig)) {
      // Normaliza los campos antes de asignar al servicio
      if (historyConfig?.form) {
        const form = historyConfig.form;

        if (typeof form.startTime === 'string') {
          form.startTime = new Date(form.startTime);
        }
        if (typeof form.endTime === 'string') {
          form.endTime = new Date(form.endTime);
        }
        if (typeof form.startDate === 'string' && form.startDate.includes('T')) {
          form.startDate = form.startDate.split('T')[0];
        }
        if (typeof form.endDate === 'string' && form.endDate.includes('T')) {
          form.endDate = form.endDate.split('T')[0];
        }
      }

      this.historialService.config = historyConfig;
    }

    // VEHICLE_CARD
    const vehicleCard = settings[ConfigKeys.VEHICLE_CARD];
    if (this.isValidSetting(vehicleCard)) {
      this.customPanelVehicleService.setConfigurationPanel(vehicleCard);
    }

    // THEME
    const theme = settings[ConfigKeys.THEME];
    if (this.isValidSetting(theme)) {
      if (theme.colorSaved) {
        this.localStorageService.setItem(this.themeService.themeColorStorageKey, theme.colorSaved);
        this.themeService.colorSaved = theme.colorSaved;
      }

      if (theme.theme) {
        this.localStorageService.setItem(this.themeService.themeStorageKey, theme.theme);
        this.themeService.currentThemeSubject.next(theme.theme);
        this.themeService.selectTheme(theme.theme);
      }
    }
  }



}
